import { Footer, Sidebar, TopBar } from './components';
import React, { useState } from 'react';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import pages from '../siteMenuMappings';
import useMediaQuery from '@mui/material/useMediaQuery';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import { useTheme } from '@mui/material/styles';

const Main = ({ children, colorInvert = false, bgColor = 'transparent' }) => {
	const theme = useTheme();
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true
	});
	
	const [openSidebar, setOpenSidebar] = useState(false);

	const handleSidebarOpen = () => {
		setOpenSidebar(true);
	};

	const handleSidebarClose = () => {
		setOpenSidebar(false);
	};

	const open = isMd ? false : openSidebar;

	const trigger = useScrollTrigger({
		disableHysteresis: true,
		threshold: 38
	});

	return (
		<Box bgcolor={bgColor}>
			<AppBar
				position={'sticky'}
				sx={{
					top: 0,
					backgroundColor: theme.palette.primary.main
				}}
				elevation={trigger ? 1 : 0}>
				<Box padding={1}>
					<TopBar
						onSidebarOpen={handleSidebarOpen}
						pages={pages}
						colorInvert={trigger ? false : colorInvert}
					/>
				</Box>
			</AppBar>

			<Sidebar onClose={handleSidebarClose} open={open} variant='temporary' pages={pages} />

			<main>
				{children}
				<Divider />
			</main>

			<Footer />
		</Box>
	);
};

Main.propTypes = {
	children: PropTypes.node,
	colorInvert: PropTypes.bool
	/* 
  bgcolor: PropTypes.string, 
  */
};

export default Main;

